import L from 'leaflet';
import 'leaflet-ant-path';
import 'leaflet.icon.glyph';
import { isEmpty } from 'lodash';
import moment from 'moment';
import { Fragment, useEffect, useRef, useState } from 'react';
import { renderToString } from 'react-dom/server';
import { useIntl } from 'react-intl';
import { Marker, Tooltip, useMapEvents } from 'react-leaflet';
import { useDispatch, useSelector } from 'react-redux';
import { useMediaQuery } from 'react-responsive';
import { useHistory, useLocation } from 'react-router-dom';
import { Media } from 'reactstrap';
import useDeepCompareEffect from 'use-deep-compare-effect';
import Icon from 'utility/icomoon';
import { UNIT_FETCH_INTERVAL } from 'views/screens/Units/types';
import { getDatesDifferenceString, getIconByDatesDifference } from 'views/screens/Units/utils';
import { ShowHistoricalPositions } from 'views/screens/Units/views/SlidingPaneUnitHistoricalPositionsReport';
import * as authSelectors from '../../../../../redux/reducers/auth';
import * as unitActions from '../../../../screens/Units/actions';
import * as unitSelectors from '../../../../screens/Units/reducers';
import SlidingPaneUnitInformation from '../../../../screens/Units/views/SlidingPaneUnitInformation';
import EventMarkerPulse from '../EventMarkerPulse';
import MarkerClusterGroup from '../MarkerClusterGroup';
export interface MapUnitsOptions {
  isSelectedSomething?: any;
  setIsSelectedSomething?: Function;
  setMapPositionToUnitBounds?: boolean;
  setMapPositionToUnitsAndPositionsBounds?: boolean;
  useSlidingPaneUnitInformation?: boolean;
  useSlidingpanelUnitInformation?: boolean;
  showHistoricalPositions?: ShowHistoricalPositions;
  usePopovers?: boolean;
  usePermanentPopover?: boolean;
  localUnitLabelsVisible?: boolean; // New prop for local unit labels state
  useLocalUnitLabels?: boolean; // New prop to indicate if using local state
  units?: any[]; // la lista de unidades que actualimente tiene el mapa
  selectedUnitIds?: any[]; // se utiliza unicamente para resaltar los Markers de unidades en el mapa
  showUnits?: boolean;
  clusterMarkers?: boolean;
  isMapFullScreen?: boolean;
  useIsShownUnit?: boolean; //param only when you have a property in each unit isShownInMap to show units on map
  initialShowSlidingPanelUnitInformationOpen?: boolean;
  initialUnitInformationOpenId?: any;
  selectedUnit?: any;
  setSelectedUnit?: (value) => void;
  selectedUnitRef?: any;
  startClusteringAt?: number;
  startRerender?: any;
  isFetchingUnits?: boolean;
  zoomLimitSet?: any;
  resetMapHome?: any;
  spiderfyProps?: any;
  showTrajectory?: boolean;
  setShowTrajectory?: any;
  trackUnitNewWindowActive?: boolean;
  trackUnitNewWindowGridActive?: boolean;
  sharedLinkUnit?: boolean;
}

const MapUnits = (props: MapUnitsOptions) => {
  //const context = useLeafletContext();

  const map = useMapEvents({
    moveend: () => {
      displayMarkers();
    }
  });

  const location = useLocation();
  const history = useHistory();
  const isDesktop = useMediaQuery({ minWidth: 1024 });
  const {
    isSelectedSomething,
    setIsSelectedSomething,
    showUnits = false,
    useIsShownUnit = false,
    units = [],
    selectedUnitIds,
    setMapPositionToUnitBounds = false,
    setMapPositionToUnitsAndPositionsBounds = false,
    useSlidingPaneUnitInformation = true,
    clusterMarkers = true,
    usePopovers,
    usePermanentPopover = false,
    localUnitLabelsVisible, // New prop for local state
    useLocalUnitLabels = false, // New prop to indicate if using local state
    showHistoricalPositions,
    isMapFullScreen = false,
    initialShowSlidingPanelUnitInformationOpen = false,
    initialUnitInformationOpenId,
    selectedUnit,
    setSelectedUnit,
    selectedUnitRef,
    startClusteringAt = undefined,
    startRerender,
    zoomLimitSet = false,
    resetMapHome,
    spiderfyProps,
    showTrajectory,
    setShowTrajectory,
    trackUnitNewWindowActive = false,
    trackUnitNewWindowGridActive = false,
    sharedLinkUnit = false
  } = props;

  const {
    store,
    user,
    isUnitsRotationMarkersActive,
    selectedUnitState,
    isFetchingUnitById,
    isFetchingUnitTrajectory,
    isFetchingUnitInformation
  } = useSelector((state) => ({
    store: state,
    user: authSelectors.getAuthUser(state),
    isUnitsRotationMarkersActive: authSelectors.getAuthUserUnitsMarkerRotationActive(state),
    selectedUnitState: selectedUnit?.unitId
      ? unitSelectors.getUnit(state, selectedUnit?.unitId) ?? null
      : null,
    isFetchingUnitById:
      unitSelectors.isFetchingUnitById(state) || unitSelectors.isFetchingUnitInformation(state),
    isFetchingUnitTrajectory: unitSelectors.isFetchingUnitTrajectory(state),
    isFetchingUnitInformation: unitSelectors.isFetchingUnitInformation(state)
  }));

  const fetchPositionInterval = useRef<any>();
  const dispatch = useDispatch();
  const intl = useIntl();
  const [showUnitInformationSlidingPane, setShowUnitInformationSlidingPane] = useState(false);
  const [liveSelectedUnit, setLiveSelectedUnit] = useState<any>();
  const [setMapPositionToUnitsBounds, changeSetMapPositionToUnitsBounds] = useState<boolean>(true);
  const [isFollowUnitPositionEnabled, setIsFollowUnitPositionEnabled] = useState<boolean>(false);

  useEffect(() => {
    if (setIsSelectedSomething) {
      setIsSelectedSomething({
        ...isSelectedSomething,
        units: selectedUnit?.unitId != null
      });
    }
  }, [selectedUnit]);

  const zoomMapToUnit = (latLng) => {
    if (setMapPositionToUnitsBounds) {
      var ll;
      if (latLng instanceof L.LatLng) {
        ll = latLng;
      } else {
        ll = L.latLng(latLng);
      }
      map.flyToBounds([ll], {
        paddingBottomRight: [550, 0],
        paddingTopLeft: [0, 70],
        maxZoom: 15,
        animate: 15 !== map.getZoom()
      });
    }
  };

  const zoomMapToUnitMobile = (latLng) => {
    if (setMapPositionToUnitsBounds) {
      var ll;
      if (latLng instanceof L.LatLng) {
        ll = latLng;
      } else {
        ll = L.latLng(latLng);
      }
      map.flyToBounds([latLng], {
        paddingBottomRight: [0, 0],
        paddingTopLeft: [0, 400],
        maxZoom: 15,
        animate: 15 !== map.getZoom()
      });
    }
  };

  const cleanup = () => {
    if (fetchPositionInterval.current) clearInterval(fetchPositionInterval.current);
  };

  useEffect(() => {
    return () => cleanup();
  }, []);

  useDeepCompareEffect(() => {
    if (units.length > 0) {
      if (setMapPositionToUnitBounds && map) {
        // Solo aplicar flyToBounds automático si NO están activas las condiciones específicas de track
        if (units.length == 1 && !trackUnitNewWindowActive && !trackUnitNewWindowGridActive) {
          const [firstUnit] = units;
          if (firstUnit?.latitude != null && firstUnit?.longitude != null) {
            var ll = L.latLng(firstUnit?.latitude, firstUnit?.longitude);
            map.flyToBounds(ll.toBounds(800), {});
          }
        } else if (units.length > 1) {
          let bounds = L.latLngBounds(units.map((loc) => [loc.latitude, loc.longitude]));
          map.fitBounds(bounds);
        }
      }
      cleanup();
      if ((showUnits || useIsShownUnit) && startRerender) {
        // startRerender(true);
        fetchPositionInterval.current = setInterval(() => {
          startRerender(true);
        }, UNIT_FETCH_INTERVAL);
      }
    }
  }, [
    (units || []).map((unit) => unit?.unitId),
    setMapPositionToUnitBounds,
    showUnits,
    useIsShownUnit,
    trackUnitNewWindowActive,
    trackUnitNewWindowGridActive
  ]);

  // useEffect para centrar el mapa en unidades y posiciones históricas
  useEffect(() => {
    if (!map) return;
    if (!setMapPositionToUnitsAndPositionsBounds) return;
    if (!showHistoricalPositions?.show) return;

    // 1) Paradas / históricos desde las unidades
    const histPoints = units
      .filter((u) => u && u?.positions && Array.isArray(u.positions)) // Validación más robusta
      .flatMap((u) => u.positions)
      .map((p) => ({
        lat: p.lat ?? p.latitude,
        lng: p.lng ?? p.longitude
      }))
      .filter((p) => p.lat != null && p.lng != null);

    if (histPoints.length === 0) return;

    const unitPoints = units
      .filter((u) => u && u?.latitude != null && u?.longitude != null) // Validación más robusta
      .map((u) => ({ lat: u.latitude, lng: u.longitude }));

    const points = [...unitPoints, ...histPoints];

    if (points.length === 1) {
      map.setView([points[0].lat, points[0].lng], 15);
    } else {
      map.fitBounds(L.latLngBounds(points.map((p) => [p.lat, p.lng])), {
        padding: [40, 40]
      });
    }
  }, [
    map,
    setMapPositionToUnitsAndPositionsBounds,
    showHistoricalPositions?.show,
    // hash de las posiciones históricas de las unidades
    units
      .filter((u) => u && u.positions)
      .map(
        (u) =>
          u.positions?.map((p) => `${p.lat ?? p.latitude}-${p.lng ?? p.longitude}`).join('|') || ''
      )
      .join(','),
    units
      .filter((u) => u)
      .map((u) => `${u.latitude}-${u.longitude}`)
      .join('|')
  ]);

  //Open and select unit if params are set
  useEffect(() => {
    if (
      !isFetchingUnitById &&
      (selectedUnit === undefined || selectedUnit?.unitId !== initialUnitInformationOpenId)
    ) {
      if (initialShowSlidingPanelUnitInformationOpen && useSlidingPaneUnitInformation) {
        if (initialUnitInformationOpenId !== undefined) {
          const initialUnitInformation = unitSelectors.getUnit(store, initialUnitInformationOpenId);
          if (
            initialUnitInformation?.latitude != null &&
            initialUnitInformation?.longitude != null
          ) {
            //setInitialUnitId(initialUnitInformation.unitId);
            //setEditingUnitParent(initialUnitInformation);
            if (setSelectedUnit) setSelectedUnit(initialUnitInformation);
            var ll = L.latLng(initialUnitInformation.latitude, initialUnitInformation.longitude);
            zoomMapToUnit(ll);
            //map.flyToBounds(ll.toBounds(800), {});
          }
          setShowUnitInformationSlidingPane(true);
        }
      }
    }
  }, [initialUnitInformationOpenId, isFetchingUnitById]);

  useEffect(() => {
    if (!initialShowSlidingPanelUnitInformationOpen) setShowUnitInformationSlidingPane(false);
  }, [initialShowSlidingPanelUnitInformationOpen]);

  // Check if you want to cluster markers
  let WrapperMarkerClusterGroup = Fragment;
  let icon: JSX.Element | undefined = undefined;
  if (clusterMarkers && map) {
    WrapperMarkerClusterGroup = MarkerClusterGroup;
    icon = <Icon icon={'Unidades'} size={12} />;
  }

  const [markersComponents, setMarkersComponents] = useState<JSX.Element[]>([]);
  const [isStartClusteringAtSet, setIsStartClusteringAtSet] = useState<boolean>(false);
  const [trayectoryPolyline, setTrayectoryPolyline] = useState<L.Polyline | null>(null);
  const [trajectoryPositions, setTrajectoryPositions] = useState<any>([]);
  const [trajectoryParkedPositionsMarkers, setTrajectoryParkedPositionsMarkers] = useState<
    JSX.Element[]
  >([]);
  const [isTrajectoryDisable, setIsTrajectoryDisable] = useState<boolean>(!showTrajectory);
  const [trayectoryFetched, setTrayectoryFetched] = useState<boolean>(!showTrajectory);
  const [lastFetchedUnitId, setLastFetchedUnitId] = useState<number | null>(null);

  // Resetear trayectoryFetched cuando cambia la unidad seleccionada
  useEffect(() => {
    if (selectedUnit?.unitId && selectedUnit?.unitId !== lastFetchedUnitId) {
      setTrayectoryFetched(false);
    }
  }, [selectedUnit?.unitId, lastFetchedUnitId]);

  useEffect(() => {
    if (isTrajectoryDisable == true && trayectoryPolyline && showTrajectory)
      map.removeLayer(trayectoryPolyline);
    console.log('MapWidget - trayectoryPolyline', trayectoryPolyline);
    if (
      isTrajectoryDisable == false &&
      trayectoryPolyline &&
      selectedUnit?.unitId &&
      showTrajectory
    ) {
      trayectoryPolyline.addTo(map);
      map.fitBounds(trayectoryPolyline.getBounds());
      console.log('MapWidget - trayectoryPolyline added to map', trayectoryPolyline);
    }
  }, [isTrajectoryDisable]);

  useEffect(() => {
    console.log(
      'MapWidget - dispatch startFetchingUnitTrajectory',
      selectedUnit?.unitId,
      trayectoryFetched,
      showTrajectory
    );
    if (showTrajectory && selectedUnit?.unitId && trayectoryFetched === false) {
      dispatch(unitActions.startFetchingUnitTrajectory(selectedUnit?.unitId, 50));
      setTrayectoryFetched(true);
      setLastFetchedUnitId(selectedUnit?.unitId);
    } else if (showTrajectory && selectedUnit === undefined)
      setTrajectoryParkedPositionsMarkers([]);
  }, [showTrajectory, selectedUnit]);

  useEffect(() => {
    if (
      showTrajectory &&
      selectedUnitState?.trajectory?.polyline?.length > 0 &&
      !isFetchingUnitTrajectory
    ) {
      // Si ya tenemos una polyline para esta unidad, no crear una nueva
      if (trayectoryPolyline && selectedUnit?.unitId === lastFetchedUnitId) {
        return;
      }

      const positions = selectedUnitState?.trajectory?.allPositions
        .sort((a, b) => moment(b.gpsDate).diff(moment(a.gpsDate)))
        .map((pos) => [pos.latitude, pos.longitude]);

      setTrajectoryPositions(positions);

      if (selectedUnitState?.trajectory?.parkedPositions.length !== 0) {
        setTrajectoryParkedPositionsMarkers(
          selectedUnitState?.trajectory.parkedPositions.map((position, index) => (
            <Marker
              key={`${index}-${position.id}`}
              // pmIgnore={true}
              zIndexOffset={700}
              riseOnHover={true}
              icon={L.divIcon({
                className: 'custom-div-icon',
                html: renderToString(
                  <Icon
                    icon={getIconByDatesDifference(position.endDate, position.gpsDate)}
                    size={48}
                  />
                ),
                iconSize: [30, 30],
                iconAnchor: [15, 15]
              })}
              position={[position.latitude, position.longitude]}
              eventHandlers={{
                click: () => {}
              }}
            >
              <Tooltip>
                <b style={{ fontSize: '11px' }}>
                  {moment(position.gpsDate).format('YYYY-MM-DD HH:mm')}
                </b>
                <br />
                <b style={{ fontSize: '11px' }}>
                  {`${intl.formatMessage({ id: 'units.duration' })}: ${getDatesDifferenceString(
                    position.endDate,
                    position.gpsDate,
                    intl
                  )}`}
                </b>
                <br />
                <b style={{ fontSize: '11px' }}>{position.locationName}</b>
              </Tooltip>
            </Marker>
          ))
        );
      }

      // Limpiar polyline anterior si existe
      if (trayectoryPolyline) {
        map.removeLayer(trayectoryPolyline);
      }

      // @ts-ignore
      const antPolyline = L.polyline.antPath(positions, {
        delay: 1000,
        dashArray: [10, 20],
        weight: 4,
        color: '#0033cc',
        pulseColor: '#FFFFFF',
        paused: false,
        reverse: true,
        hardwareAccelerated: true
      });

      antPolyline.addTo(map);
      setTrayectoryPolyline(antPolyline);
    } else if (!showTrajectory && trayectoryPolyline) {
      map.removeLayer(trayectoryPolyline);
      setTrayectoryPolyline(null);
      setTrajectoryParkedPositionsMarkers([]);
      setTrajectoryPositions([]);
    }
  }, [selectedUnitState?.trajectory?.polyline, isFetchingUnitTrajectory, map, showTrajectory, selectedUnit?.unitId]);

  useDeepCompareEffect(() => {
    if (
      selectedUnit &&
      showTrajectory &&
      (showUnitInformationSlidingPane || trackUnitNewWindowActive)
    ) {
      const liveUnit = units
        .filter((unit) => unit.unitId === selectedUnit.unitId)
        .map((unit) => {
          return {
            unitId: unit.unitId,
            latitude: unit.latitude,
            longitude: unit.longitude
          };
        });

      if (
        trajectoryPositions.length > 0 &&
        trajectoryPositions[0][0] !== liveUnit[0]?.latitude &&
        trajectoryPositions[1][1] !== liveUnit[0]?.longitude
      ) {
        trayectoryPolyline?.setLatLngs([
          [liveUnit[0]?.latitude, liveUnit[0]?.longitude],
          ...trajectoryPositions
        ]);
        setTrajectoryPositions((prevPositions) => [
          [selectedUnitState?.latitude, selectedUnitState?.longitude],
          ...prevPositions
        ]);
      }
    }
  }, [
    units?.map((unit) => ({
      latitude: unit?.latitude,
      longitude: unit?.longitude
    })),
    showUnitInformationSlidingPane,
    selectedUnit,
    showTrajectory
  ]);

  useEffect(() => {
    // Priorizar selectedUnitState sobre selectedUnit
    const unitLatitude = selectedUnitState?.latitude ?? selectedUnit?.latitude;
    const unitLongitude = selectedUnitState?.longitude ?? selectedUnit?.longitude;

    if (
      unitLatitude != null &&
      unitLongitude != null &&
      unitLatitude !== 0 &&
      unitLongitude !== 0
    ) {
      // Condición 1: trackUnitNewWindowGridActive = true
      if (trackUnitNewWindowGridActive) {
        var ll = L.latLng([unitLatitude, unitLongitude]);
        map.flyToBounds(ll.toBounds(800), {
          paddingBottomRight: [0, 0],
          paddingTopLeft: [0, 0],
          maxZoom: 15,
          animate: true
        });
      }
      // Condición 2: trackUnitNewWindowActive = true y solo hay una unidad seleccionada
      else if (trackUnitNewWindowActive && units.length === 1) {
        var ll = L.latLng([unitLatitude, unitLongitude]);
        map.flyToBounds(ll.toBounds(800), {
          paddingBottomRight: [0, 0],
          paddingTopLeft: [0, 0],
          maxZoom: 15,
          animate: true
        });
      }
      // Condición 3: trackUnitNewWindowActive === false && isFollowUnitPositionEnabled === true
      else if (trackUnitNewWindowActive === false && isFollowUnitPositionEnabled === true) {
        zoomMapToUnit([unitLatitude, unitLongitude]);
      }
    }
  }, [
    selectedUnitState?.latitude,
    selectedUnitState?.longitude,
    selectedUnit?.latitude,
    selectedUnit?.longitude,
    trackUnitNewWindowActive,
    trackUnitNewWindowGridActive,
    isFollowUnitPositionEnabled,
    units.length
  ]);

  const displayMarkers = () => {
    if (zoomLimitSet && !isStartClusteringAtSet) {
      setMarkersComponents([]);
      setIsStartClusteringAtSet(true);
    } else if (spiderfyProps && spiderfyProps.spiderfyActivated) {
      setMarkersComponents([]);
      spiderfyProps.setSpiderfyActivated(false);
    } else {
      setMarkersComponents(
        units
          .filter(
            (unit) =>
              unit &&
              unit?.latitude != null &&
              unit?.longitude != null &&
              (map ? map.getBounds().contains(L.latLng(unit.latitude, unit.longitude)) : true)
          )
          .filter(
            (unit) =>
              unit.latitude != null &&
              unit.longitude != null &&
              ((showUnits && !useIsShownUnit) || (useIsShownUnit && unit.isShownInMap))
          )
          .map((unit) => {
            const heading = unit.heading ?? -1;
            let rotationStyle = '';

            if (heading !== -1) {
              let rotation = heading % 360; // Normalizar la rotacion

              const mirror = rotation > 90 && rotation < 270 ? 'scaleY(-1)' : '';

              rotationStyle = `rotate(${rotation}deg) ${mirror}`;
            }

            // Simplificar lógica de tooltip
            const shouldBePermanent = usePermanentPopover || 
              (useLocalUnitLabels ? localUnitLabelsVisible : user?.unitMapLabelAlwaysOn == 1);
            
            const uniqueKey = `${unit.unitId}-${shouldBePermanent}-${usePopovers}`;

            return (
              <div key={uniqueKey}>
                <Marker
                  // pmIgnore={true}
                  zIndexOffset={
                    selectedUnitIds &&
                    selectedUnitIds.length > 0 &&
                    selectedUnitIds.includes(unit.unitId)
                      ? 850
                      : 800
                  }
                  riseOnHover={!shouldBePermanent}
                  icon={L.divIcon({
                    className: 'custom-div-icon',
                    html: renderToString(
                      <EventMarkerPulse
                        unit={unit}
                        selectedUnitIds={selectedUnitIds}
                        isUnitsRotationMarkersActive={isUnitsRotationMarkersActive}
                        rotationStyle={rotationStyle}
                        iconSize={30}
                        iconColor="rgba(128, 128, 128, 0.6)"
                      />
                    ),
                    iconSize: [30, 30],
                    iconAnchor: [15, 15],
                    popupAnchor: [0, -18]
                  })}
                  position={[unit.latitude, unit.longitude]}
                  eventHandlers={{
                    click: (e) => {
                      // if (editingUnitParentRef?.current) {
                      //   history.replace();
                      //   dispatch(unitActions.showUnitInMap(editingUnitParentRef?.current.unitId));
                      //   if (setEditingUnitParent) setEditingUnitParent(undefined);
                      // }
                      if (setSelectedUnit) {
                        console.log('entra al selected unit: ', unit);
                        setSelectedUnit(unit);
                      }
                      if (useSlidingPaneUnitInformation) {
                        setShowUnitInformationSlidingPane(true);
                      }
                      zoomMapToUnit(e.latlng);
                    }
                  }}
                >
                  {' '}
                  {usePopovers && (
                    <Tooltip
                      permanent={shouldBePermanent}
                      direction={'bottom'}
                      offset={[0, 10]}
                      className={'unit-map-label'}
                    >
                      <b className="text-center" style={{ fontSize: '11px' }}>
                        {unit?.alias?.toUpperCase() || unit.unitName.toUpperCase()}
                      </b>
                      {user?.unitsLabelContent?.split(',').map((l) => (
                        <>
                          {l == '0' && (
                            <>
                              <br />
                              <span>{!isEmpty(unit.locationName) ? unit.locationName : 'N/A'}</span>
                            </>
                          )}
                          {l == '1' && (
                            <>
                              <br />
                              <span>
                                {unit.gpsDate
                                  ? moment(unit.gpsDate).format('YYYY-MM-DD HH:mm')
                                  : 'N/A'}
                              </span>
                            </>
                          )}
                          {l == '2' && (
                            <>
                              <br />
                              <span>
                                {unit.lastCommunicationDate
                                  ? moment(unit.lastCommunicationDate).format('YYYY-MM-DD HH:mm')
                                  : 'N/A'}
                              </span>
                            </>
                          )}
                          {l == '3' && (
                            <>
                              <br />
                              <span>{unit.odometerFormat || 'N/A'}</span>
                            </>
                          )}
                          {l == '4' && (
                            <>
                              <br />
                              <span>{unit.speedFormat || 'N/A'}</span>
                            </>
                          )}
                        </>
                      ))}

                      {unit.fullImageUrl && (
                        <>
                          <br /> <br />
                          <Media
                            src={unit.fullImageUrl}
                            height="90"
                            width="90"
                            style={{
                              display: 'block',
                              marginLeft: 'auto',
                              marginRight: 'auto'
                            }}
                          />
                        </>
                      )}
                    </Tooltip>
                  )}
                </Marker>
              </div>
            );
          })
      );
    }
  };
  useDeepCompareEffect(() => {
    if (showUnits || useIsShownUnit) {
      displayMarkers();
    }
  }, [
    showUnits,
    units?.map((unit) => ({
      latitude: unit?.latitude,
      longitude: unit?.longitude,
      isShownInMap: unit?.isShownInMap
    })),
    startClusteringAt,
    isStartClusteringAtSet,
    spiderfyProps?.spiderfyActivated,
    user?.unitMapLabelAlwaysOn,
    user?.unitsLabelContent,
    usePermanentPopover,
    localUnitLabelsVisible,
    useLocalUnitLabels
  ]);

  return (
    <>
      {(showUnits || useIsShownUnit) && clusterMarkers ? (
        <WrapperMarkerClusterGroup
          key={startClusteringAt}
          {...(clusterMarkers && map
            ? {
                icon: icon,
                disableClusteringAtZoom: startClusteringAt,
                spiderfyOnMaxZoom: spiderfyProps?.spiderfyState
              }
            : {})}
        >
          {markersComponents.length > 0 ? markersComponents : null}
        </WrapperMarkerClusterGroup>
      ) : markersComponents.length > 0 ? (
        markersComponents
      ) : null}
      {showTrajectory &&
      selectedUnit?.unitId &&
      trajectoryParkedPositionsMarkers.length &&
      !isTrajectoryDisable
        ? trajectoryParkedPositionsMarkers
        : null}
      {showHistoricalPositions?.show ? (
        units
          .filter((unit) => unit && unit?.unitId)
          .map((unit) => (
            <SlidingPaneUnitInformation
              closeSlidingPane={() => {}}
              changeSetMapPositionToUnitsBounds={() => {}}
              key={unit?.unitId}
              showHistoricalPositions={showHistoricalPositions}
              isSlidingPaneOpen={showUnitInformationSlidingPane}
              title={unit?.unitName}
              unitId={unit?.unitId}
              selectedUnit={selectedUnit}
              selectedUnitRef={selectedUnitRef}
              setSelectedUnit={setSelectedUnit}
              setIsTrajectoryDisable={setIsTrajectoryDisable}
              isFollowUnitPositionEnabled={isFollowUnitPositionEnabled}
              setIsFollowUnitPositionEnabled={setIsFollowUnitPositionEnabled}
              handleRecenterMapPosition={zoomMapToUnit}
            />
          ))
      ) : selectedUnit?.unitId && trackUnitNewWindowActive === false ? (
        //  && (showTrajectory === false || showTrajectory === undefined)
        <SlidingPaneUnitInformation
          closeSlidingPane={() => {
            setShowUnitInformationSlidingPane(false);
            //unitContextValue.changeUnitState({ isSelected: false });
            setSelectedUnit(undefined);
            setIsFollowUnitPositionEnabled(false);
            if (
              initialUnitInformationOpenId &&
              initialShowSlidingPanelUnitInformationOpen &&
              resetMapHome
            ) {
              resetMapHome();
            }
            if (setShowTrajectory) {
              setShowTrajectory(false);
            }
          }}
          setMapPositionToPositionsBounds={true}
          changeSetMapPositionToUnitsBounds={changeSetMapPositionToUnitsBounds}
          showHistoricalPositions={showHistoricalPositions}
          isSlidingPaneOpen={showUnitInformationSlidingPane}
          title={selectedUnit?.unitName}
          unitId={selectedUnit?.unitId}
          selectedUnit={selectedUnit}
          selectedUnitRef={selectedUnitRef}
          setSelectedUnit={setSelectedUnit}
          setIsTrajectoryDisable={setIsTrajectoryDisable}
          isFollowUnitPositionEnabled={isFollowUnitPositionEnabled}
          setIsFollowUnitPositionEnabled={setIsFollowUnitPositionEnabled}
          handleRecenterMapPosition={zoomMapToUnit}
        />
      ) : null}
    </>
  );
};

MapUnits.defaultProps = {
  setMapPositionToUnitBounds: false,
  useSlidingPaneUnitInformation: true,
  units: [],
  showUnits: false,
  clusterMarkers: true,
  isMapFullScreen: false,
  initialShowSlidingPanelUnitInformationOpen: false,
  usePopovers: true,
  initialUnitInformationOpenId: undefined,
  useIsShownUnit: false
};

export default MapUnits;
